import { HttpParams } from '@angular/common/http';
import { isSignal, Signal } from '@angular/core';
import { Route } from '@angular/router';

import { from, Observable, of } from 'rxjs';

import { resolveValue } from '@lvflanders/bar';

import { barPageNotFoundGuard } from '../guards/bar-page-not-found.guard';
import { BarPageNotFoundComponent } from '../pages/bar-page-not-found.component';
/**
 * Will return an Observable based on a value which can be of different types.
 * @param value
 */
export function resolveValue$(value: Observable<any> | Promise<any> | any | (() => any)): Observable<any> {
    if (value instanceof Observable) {
        return value;
    }
    if (value instanceof Promise) {
        return from(value);
    }
    const resolvedValue = resolveValue(value);
    return of(resolvedValue);
}

export function resolveSignalValue<T>(value: Signal<T> | T): T {
    return isSignal(value) ? value() : value;
}
/**
 * Convers an object to a http params.
 * @param obj
 */
// https://github.com/angular/angular/issues/18012
export function convertToHttpParams(obj: any): HttpParams {
    let params = new HttpParams();
    if (obj != null) {
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                const val = obj[key];
                if (val !== null && val !== undefined) {
                    params = params.append(key, val.toString());
                }
            }
        }
    }
    return params;
}
/** Creates the default base href factory. The base href factory generated will ensure the base href match is done in a case insensitive way. Use this when providing APP_BASE_HREF.*/
export function createDefaultBaseHrefFactory(baseHref: string) {
    return () => {
        if (!baseHref || baseHref === '/') return baseHref;
        // do not take into account end slash because pathname is not with end slash
        const comparisonBaseHref = baseHref.endsWith('/') ? baseHref.substring(0, baseHref.length - 1) : baseHref;
        if (!window.location.pathname.toLowerCase().startsWith(comparisonBaseHref.toLowerCase())) return baseHref;
        return window.location.pathname.substring(0, comparisonBaseHref.length);
    };
}

export function createPageNotFoundRoute(path: string) {
    return {
        path,
        component: BarPageNotFoundComponent,
        canActivate: [barPageNotFoundGuard()],
        data: { _framework: true }
    } as Route;
}
